import fetch from 'utilities/fetch';

import {paths} from 'config/path_helpers';

export function fetchStudentData(page: number, startDate?: string, endDate?: string, fetchOptions?) {
  return fetch(paths.api.studentRow(page, startDate, endDate), fetchOptions || {})
}
